import React, { useMemo, useState, useEffect } from "react";
import { get } from "lodash";
import { getRunner } from "@tvg/utils/getRaceAtiveRunner";
import Icon from "@tvg/atomic-ui/_static/Icons";
import { caretDown, caretUp } from "@tvg/atomic-ui/_static/Icons/icons";
import buildColor from "@fdr/static-ui/ColorPalette";
import { formatOdds } from "./utils";
import {
  RunnerOddsContainer,
  OddsContainer,
  MorningOdds,
  OddsTitle,
  CommentsContainer,
  Comment,
  SilkContainer,
  Silk,
  Odd,
  RunnerOddsWrapper
} from "./styled-components";
import { Props } from "./types";

export const HorseOddsPP = (props: Props) => {
  const [hasSilkError, setSilkError] = useState(false);

  const { activeRunnerBI, activeRunner, noRunnerCommentMessage, isSilkShown } =
    props;

  const runner = useMemo(
    () => getRunner(activeRunnerBI, activeRunner),
    [activeRunnerBI, activeRunner]
  );
  const silkUrlSvg = get(runner, "timeform.silkUrlSvg");

  useEffect(() => {
    setSilkError(false);
  }, [silkUrlSvg]);

  return useMemo(
    () =>
      runner ? (
        <RunnerOddsWrapper>
          <RunnerOddsContainer>
            <OddsContainer>
              <MorningOdds>
                <OddsTitle>Odds:</OddsTitle> M/L{" "}
                {formatOdds(activeRunnerBI.morningLineOdds)}
              </MorningOdds>
              {activeRunnerBI.recentOdds &&
                activeRunnerBI.recentOdds
                  .map((odd, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Odd key={`odd-${index}`}>
                      {odd.trending !== null &&
                        index !==
                          get(activeRunnerBI, "recentOdds.length") - 1 && (
                          <Icon
                            icon={!odd.trending ? caretUp : caretDown}
                            size={15}
                            color={
                              !odd.trending
                                ? buildColor("green")
                                : buildColor("red")
                            }
                          />
                        )}
                      {odd.odd}
                    </Odd>
                  ))
                  .reverse()}
            </OddsContainer>
            <CommentsContainer>
              <Comment>
                {get(
                  runner,
                  "timeform.analystsComments",
                  noRunnerCommentMessage
                ) || noRunnerCommentMessage}
              </Comment>
            </CommentsContainer>
          </RunnerOddsContainer>
          {isSilkShown && !!silkUrlSvg && !hasSilkError && (
            <SilkContainer>
              <Silk src={silkUrlSvg} onError={() => setSilkError(true)} />
            </SilkContainer>
          )}
        </RunnerOddsWrapper>
      ) : null,
    [
      runner,
      isSilkShown,
      activeRunner,
      JSON.stringify(activeRunnerBI),
      hasSilkError
    ]
  );
};

export default HorseOddsPP;
